import { Filter, FilterType } from '../../search.filter/search-filter.component';
import { usStates } from '../inspection-search-results/filter-configurations';

export const configuredFilters: Filter[] = [
  {
    type: FilterType.TEXTWITHOR,
    name: 'policyNumber',
    label: 'Policy Number',
    group: 'Policy',
  },
  {
    type: FilterType.DATE,
    name: 'policyEffectiveDate',
    label: 'Policy Effective Date',
    group: 'Policy',
  },

  {
    type: FilterType.TEXTWITHOR,
    name: 'customerName',
    label: 'Customer Name',
    group: 'Customer',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'address',
    label: 'Address',
    group: 'Location',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'city',
    label: 'City',
    group: 'Location',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'state',
    options: usStates,
    label: 'State',
    group: 'Location',
  },
  {
    type: FilterType.DATE,
    name: 'recommendationLetterSentDate',
    label: 'Rec letter sent',
    group: 'Rec letter',
  },
  {
    type: FilterType.DATE,
    name: 'recommendationLetterDueDate',
    label: 'Rec letter due Date',
    group: 'Rec letter',
  },
  {
    type: FilterType.NUMBERWITHCONDITION,
    name: 'noOfRecommendations',
    label: 'No. of Recs',
    group: 'Rec letter',
  },
  {
    type: FilterType.NUMBERWITHCONDITION,
    name: 'noOfRecommendationsCompleted',
    label: 'No. of Recs completed',
    group: 'Rec letter',
  },
];
